// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { togglDisplayBetSlidersByDefaultOption } from '../../actions/user';
import useMergeProps from '../../hooks/useMergeProps';
import { __ } from '../../i18n/l10n';
import { selectUserDisplayBetSliders } from '../../selectors/user/userPrimary.selector';
import ToggleOption from '../common/ToggleOption';

type DisplayBetSlidersOptionContainerProps = {
  className?: string;
};

const DisplayBetSlidersOptionContainer = (ownProps: DisplayBetSlidersOptionContainerProps) => {
  const dispatch = useDispatch();
  const isToggled = useSelector(selectUserDisplayBetSliders);

  const onToggle = useCallback(() => {
    dispatch(togglDisplayBetSlidersByDefaultOption());
  }, [dispatch]);

  const otherProps = useMemo(() => ({ isToggled, onToggle }), [isToggled, onToggle]);

  const enhancedProps = useMergeProps({ ownProps, otherProps });

  return <ToggleOption {...enhancedProps} label={__('Display sliders on relevant bets by default')} />;
};

export default DisplayBetSlidersOptionContainer;
